import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "RecommendationRequestDetails",

  propTypes: {
    body: React.PropTypes.string.isRequired,
    url: React.PropTypes.string.isRequired,
    user: GrPropTypes.user().isRequired,
  },

  renderRecommendButton() {
    return <a href={this.props.url}
              className="gr-button u-marginTopMedium u-marginBottomMedium"
              aria-label={`Recommend a book for ${this.props.user.viewableName}`}>
             Recommend a book
           </a>;
  },

  render() {
    return (
      <div className="gr-newsfeedItem__details">
        <div className="gr-newsfeed u-defaultType">
          {this.props.body}
        </div>
        {this.renderRecommendButton()}
      </div>
    );
  },
});
